module.exports = __webpack_public_path__ + "5c81187f3edf40af9d10000859ab04a5.png";


//////////////////
// WEBPACK FOOTER
// ./images/pics2/3.png
// module id = 301
// module chunks = 0